import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MARKETING_CTAS } from '@/lib/marketingCtas';

/** Close (spec 010 §5.4): the same single action the page opened with. */
export function SatAboutClose() {
  const cta = MARKETING_CTAS.courseAboutPrimary;
  const tutor = MARKETING_CTAS.courseAboutSecondary;
  return (
    <section aria-labelledby="about-close-title" className="px-4 pb-16 sm:px-6 lg:pb-24">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 rounded-3xl bg-primary px-6 py-10 text-primary-foreground sm:px-10 md:flex-row md:items-center md:justify-between lg:py-14">
        <h2 id="about-close-title" className="max-w-[20ch] text-balance text-3xl font-bold tracking-tight sm:text-4xl">
          Your course starts with one diagnostic.
        </h2>
        <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:gap-5">
          <Button asChild size="lg" className="h-12 bg-background text-base text-foreground hover:bg-background/90">
            <Link to={cta.href}>{cta.label}</Link>
          </Button>
          <Link
            to={tutor.href}
            className="self-center rounded text-sm font-medium underline underline-offset-4 hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-foreground"
          >
            {tutor.label}
          </Link>
        </div>
      </div>
    </section>
  );
}
